import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";

// A "rate contract" is an approved vendor-item mapping whose validity window
// covers the given date. This is the single place that lookup happens from
// the frontend so create-po, edit-po (and PR-linked variants of both) all
// agree on what "active" means.
export const fetchRateContractStatus = (vendorCode, itemId, poDate) => {
  if (!vendorCode || !itemId) {
    return Promise.resolve({ active: false, rate: 0, taxPercentage: 0 });
  }
  return invokeApi(
    HTTP_METHODS.GET,
    `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.VENDOR_MAPPING_GET_MAPPING}`,
    null,
    { vendorCode, item: itemId, ...(poDate ? { date: poDate } : {}) }
  )
    .then((response) => ({
      active: response?.status === "approved",
      rate: response?.price ?? 0,
      taxPercentage: response?.taxPercentage ?? 0,
    }))
    .catch(() => ({ active: false, rate: 0, taxPercentage: 0 }));
};

export const getRateContractRequiredItemIds = (poItems) => {
  return [
    ...new Set(
      Object.values(poItems || {})
        .flat()
        .filter((poItem) => poItem?.item?.rateContractRequired)
        .map((poItem) => poItem.itemId)
        .filter(Boolean)
    ),
  ];
};

